import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'weekly-column-chart',
  templateUrl: './weekly-column-chart.component.html',
  styleUrls: ['./weekly-column-chart.component.css']
})
export class WeeklyColumnChartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/weekly-column-chart/weekly-column-chart.component.ts